import {apiGetRequest, apiPostRequest} from "../utils/webrequests";
import {SponsorshipTierListItem} from "../data/sponsorInfo";

import { SponsorListItem, TierListItem } from "../data/sponsorInfo";

export interface GetSponsorsParams {
    eventId?: string;
}

export async function getSponsorshipTiers(eventId: string): Promise<SponsorshipTierListItem[]> {
    try {
        console.log("Service file: SponsorshipTiers", eventId);
        const path = `GetSponsorTiers/${eventId}`;
        const response = await apiGetRequest(path, null);
        console.log(response);

        if (response && Array.isArray(response)) {
            return response as SponsorshipTierListItem[];
        }

        console.warn('Unexpected response format from GetSponsorshipTiers API', response);
        return [];
    } catch (error: any) {
        console.error('Error in fetching Sponsorship Tiers', error);
        return [];
    }
}
export async function deleteSponsorTier(sponsorTierId: string, eventId: string): Promise<boolean> {
    try {
        console.log(`Attempting to delete Sponsor Tier with ID: ${sponsorTierId} for Event ID: ${eventId}`);

        const payload = { sponsorTierId, eventId };
        const response = await apiPostRequest("DeleteSponsorTier", payload);
        console.log(response);
        console.log(response.statusCode);

        const responseText = typeof response === "string" ? response : JSON.stringify(response);
        console.log("Response Text:", responseText);

        if (!responseText.includes("deleted successfully")) {
            console.error("Failed to delete sponsorship tier:", responseText);
            return false;
        }

        /* did not work? status returned undefined in console.
        *  if (response.statusCode !== 200) {
            console.error("Failed to delete sponsorship tier:", response);
            return false;
        }
        * */
        console.log(response.status);

        console.log(`Sponsor Tier ${sponsorTierId} deleted successfully.`);
        return true;
    } catch (error) {
        console.error("Error occurred while deleting sponsorship tier:", error);
        return false;
    }
}

/**
 * Add a new sponsorship tier.
 * @param sponsorshipTier - The sponsorship tier object WITHOUT an ID.
 */
export async function addSponsorshipTier(sponsorshipTier: Omit<SponsorshipTierListItem, "SponsorshipTierId">): Promise<any> {
    try {
        console.log("Adding Sponsorship Tier:", sponsorshipTier);
        const response = await apiPostRequest("SaveSponsorshipTier", sponsorshipTier);
        return response;
    } catch (error: any) {
        console.error("Error adding Sponsorship Tier:", error);
        throw new Error(`Failed to add sponsorship tier: ${error.message}`);
    }
}

/**
 * Edit an existing sponsorship tier.
 * @param sponsorshipTier - The sponsorship tier object WITH an ID.
 */
export async function editSponsorshipTier(sponsorshipTier: SponsorshipTierListItem): Promise<any> {
    try {
        console.log("Editing Sponsorship Tier:", sponsorshipTier);
        const response = await apiPostRequest("SaveSponsorshipTier", sponsorshipTier);
        return response;
    } catch (error: any) {
        console.error("Error editing Sponsorship Tier:", error);
        throw new Error(`Failed to edit sponsorship tier: ${error.message}`);
    }
}
export async function deleteSponsor(sponsorId: string, eventId: string): Promise<boolean> {
    try {
        // Call the DeleteSponsor function directly with both IDs in the request body
        await apiPostRequest('DeleteSponsor', {
            sponsorId: sponsorId,
            eventId: eventId
        });
        return true;
    } catch (error: any) {
        if (error.status === 404) {
            throw new Error('Sponsor not found');
        } else if (error.status === 401) {
            throw new Error('Unauthorized to delete sponsor');
        }
        throw new Error('Error deleting sponsor: ' + error.message);
    }
}

export async function getSponsorTiers(eventId: string): Promise<TierListItem[]> {
    try {
        const path = `GetSponsorTiers/${eventId}`;
        const response = await apiGetRequest(path, null);

        if (response && Array.isArray(response)) {
            return response as TierListItem[];
        }

        console.warn('Unexpected response format from GetSponsorTiers API', response);
        return [];
    } catch (error: any) {
        console.error('Error in fetching sponsor tiers', error);
        return [];
    }
}

export async function getSponsorsList(params?: GetSponsorsParams): Promise<SponsorListItem[]> {
    try {
        let path = "GetListOfSponsors";

        if (params) {
            const queryParams = new URLSearchParams();

            if (params.eventId) {
                queryParams.append("eventId", params.eventId);
            }

            const queryString = queryParams.toString();
            if (queryString) {
                path += `?${queryString}`;
            }
        }

        const response = await apiGetRequest(path, null);

        if (response && response.status === "success" && Array.isArray(response.data)) {
            return response.data as SponsorListItem[];
        }

        console.warn('Unexpected response format from GetListOfSponsors API', response);
        return [];
    } catch (error: any) {
        console.error('Error in fetching sponsors from API GetListOfSponsors', error);
        return [];
    }
}
    export async function addSponsor(sponsor: SponsorListItem): Promise<SponsorListItem> {
        try {
            // Make an API GET request to fetch event info
            const data: SponsorListItem = await apiPostRequest(`AddSponsor/${sponsor.EventId}`, sponsor)
            // Return the fetched data
            return data;

        } catch (error: any) {
            console.error('Error in addSponsor:', error);
            throw new Error('Error adding sponsor: ' + error.message);
        }
    }
    export async function editSponsor(sponsor: SponsorListItem): Promise<boolean> {
        try {
            const response = await apiPostRequest(`editSponsor/${sponsor.SponsorId}`, sponsor);
            return true;
        } catch (error: any) {
            if (error.status === 404) {
                throw new Error('Sponsor not found');
            } else if (error.status === 401) {
                throw new Error('Unauthorized to edit sponsor');
            }
            throw new Error('Error editing sponsor: ' + error.message);
        }
    }


